import 'ol/ol.css';
import { MAP_VIEWER_ROLE } from './MapViewer.constants';
import { useOlMap } from './utils/useOlMap';

export const MapViewer = (): JSX.Element => {
  const { mapRef } = useOlMap();

  return (
    <div
      ref={mapRef}
      role={MAP_VIEWER_ROLE}
      className="absolute left-[88px] top-[104px] h-[calc(100%-104px)] w-[calc(100%-88px)] bg-[#e4e2de]"
    />
  );
};
